import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface NumberBadgeProps {
  number: number
}

const NumberBadge = ({ number }: NumberBadgeProps) => {
  return (
    <Box
      style={{
        backgroundColor: '#06838B',
        color: 'white',
        width: '20px',
        height: '20px',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: '12px',
        flexShrink: '0',
      }}
    >
      {number}
    </Box>
  )
}

export default NumberBadge
